import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './inventoryCreate.html'

/**
 * Create Inventory.
 *
 * @namespace routes.OperationInventoryCreate
 * @type {TmrRoute}
 */
export const route = {
  name: 'operations.inventory.create',
  label: 'OPERATIONS.INVENTORY.CREATE.TITLE',
  url: '/inventory/create',
  params: {
    op: 'add',
  },
  resolve: {
    resource: /*@ngInject*/ Inventory => Inventory.create(),
  },
  component: 'tmrOperationInventoryCreate',
  accessControl: ['Operation.perform', 'Operation.Inventory.perform'],
}

/**
 * Create Inventory component.
 *
 * @type {ngComponent}
 */
export const tmrOperationInventoryCreate = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrOperationInventoryCreateController',
  bindings: {
    resource: '<',
  },
}

/**
 * Controller of component {@link tmrOperationInventoryCreateController}.
 *
 * @type {ngController}
 */
export class tmrOperationInventoryCreateController extends tmrResourceFormController {
  static ngType = 'controller'

  constructor(
    $scope,
    $state,
    $stateParams,
    $mdDialog,
    TmrInvalidFormError,
    TmrToast,
    TmrSearchFormFilters,
    Product,
    Place,
    Zone
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, {
      Product,
      Place,
      Zone,
      $mdDialog,
      TmrSearchFormFilters,
    })
  }

  $onInit() {
    super.$onInit()
    this.toast = 'OPERATIONS.INVENTORY.CREATE.SUCCESS'
    this.filterByProductEnabled = false
    this.filters = null
  }

  getPlaces(value) {
    return this.Place.search({ value }).$promise
  }

  getZones(description, zoneType) {
    return this.Zone.query({ description, zoneType, 'place.id': this.place.id })
      .$promise
  }

  clearZones() {
    this.resource.inventoryZones.length = 0
    this.resource.ignoredZones.length = 0
    delete this.resource.toCheckZone
    delete this.resource.lostZone
  }

  /** @override */
  save() {
    if (this.filterByProductEnabled && this.productGroup) {
      return this.Product.createProductGroup(this.productGroup).$promise.then(
        res => {
          this.resource.productGroup = res
          return super.save()
        }
      )
    } else return super.save()
  }

  showCreateProductGroupDialog(targetEvent) {
    let dialog = this.$mdDialog.tmrCreateProductGroupDialog({
      targetEvent,
      locals: { productGroup: this.productGroup },
    })
    this.$mdDialog.show(dialog).then(result => {
      this.productGroup = result.productGroup
      this.resource.productGroup = result.productGroup
      this.filters = result.filters
    })
  }
}
